module.exports = __webpack_public_path__ + "img/66.5.COD.cfbd3ff5.png";